/**
 * =============================================================================
 * nav.js
 * =============================================================================

 * =============================================================================
 */

var VisualEffectsUX = {
  selectors: {
    mySwiper: ".swiper-autoplay-in-viewport"
  },
  
  init: function() {
    this.setupScrollListener();
    document.addEventListener('interaction:down-scroll', this.onScrollDown.bind(this));
    document.addEventListener('interaction:up-scroll', this.onScrollUp.bind(this));
    let ttSwiper = document.querySelector(this.selectors.mySwiper);
    let mpSwiperContainer = document.getElementById('swiper-initializing');
    let mpSwiper = document.getElementsByClassName("swiper-autoplay-in-viewport");
    var delaySpeed = "7000";
  },

  /**
   * Automatically called by mp.js when document is ready. Perform any jQuery
   * setup for the extension here (e.g. event listeners, initial state)
   */
  onReady: function(){

  },
  onScrollDown: function() {

  },

  onScrollUp: function() {

  },

  setupScrollListener: function() {
    var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var viewportHeight = window.innerHeight;
    let viewportWidth = window.innerWidth;

    document.addEventListener('aos:in:showcase-slider', ({ detail }) => {
      document.getElementsByClassName("swiper-vertical")[0].classList.toggle('active');
    });
    
    document.addEventListener('DOMContentLoaded', function() {
      document.addEventListener('scroll', function() {
        // let documentHeight = document.body.scrollHeight;
        // let currentScroll = window.scrollY + window.innerHeight;
        // let content = document.getElementById('shopify-section-static-footer');
        /*
        if (document.getElementsByClassName("swiper-vertical")[0].classList.contains('active')) {
          document.getElementsByClassName("swiper-vertical")[0].swiper.autoplay.start();
        } else {
          document.getElementsByClassName("swiper-vertical")[0].swiper.autoplay.stop();
        }*/
      })
    });

    //Slider content overlay initialize swiper when section in viewport through AOS
    document.addEventListener('aos:in:slider-content-overlay', ({ detail }) => {
      var delaySpeed = "5000";
      // console.log('Here!', document.getElementsByClassName("swiper-autoplay-in-viewport"));
      document.getElementsByClassName("swiper-autoplay-in-viewport")[0].swiper.params.autoplay.delay=delaySpeed;
      document.getElementsByClassName("swiper-autoplay-in-viewport")[0].swiper.autoplay.start();
    });

    document.addEventListener('aos:out:slider-content-overlay', ({ detail }) => {
      document.getElementsByClassName("swiper-autoplay-in-viewport")[0].swiper.autoplay.stop();
    });

    window.addEventListener("scroll", function(){
      var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      if(MP.Utilities.isHomePage()){

      }
      if(Math.abs(st - lastScrollTop) < 200){
        return;
      }
      if (st > lastScrollTop){
        var event = new CustomEvent("interaction:down-scroll");
        document.dispatchEvent(event);
      } else {
        var event = new CustomEvent("interaction:up-scroll");
        document.dispatchEvent(event);
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);
  }
}

export default VisualEffectsUX;